import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherTypeId {
  CASH = 'cash',
  STAY_PACKAGE = 'stay_package',
}

export class GiftVoucherType extends Codebook<GiftVoucherTypeId> {
  static readonly CASH = new GiftVoucherType(GiftVoucherTypeId.CASH, () => $t('Cash'))
  static readonly STAY_PACKAGE = new GiftVoucherType(GiftVoucherTypeId.STAY_PACKAGE, () =>
    $t('Stay'),
  )

  private constructor(
    id: GiftVoucherTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
